export const sliceName = 'articleId'
